<template>
  <v-dialog
    v-model="dialog"
    persistent
  >
    <v-card>
      <v-card-title>Habilitar encerrameto?</v-card-title>
      <v-card-text>
        <form-group>
          <p>
            A loja encontrada-se com a a opção de encerramento <v-chip
              outlined
              label
              :color="getChip.color"
            >
              {{ getChip.label }}
            </v-chip>
          </p>
        </form-group>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          id="closeBtn"
          outlined
          color="primary"
          @click="handleDialogDisplay()"
        >
          Cancelar
        </v-btn>
        <v-btn
          id="send"
          class="white--text ml-2"
          color="#2ABD49"
          :loading="loading"
          @click.prevent="closingRequest()"
        >
          {{ getLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import eventBus from '@/plugins/eventBus';
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';
import StoreRequest from '../../services/StoreRequest';

export default {
  name: 'UserStoreClosingModal',
  components: { FormGroup },
  mixins: [ServiceMixin],
  data: () => ({
    dialog: false,
    loading: false,
    requestClass: StoreRequest,
    row: {
      id: '',
      indHabilitadoEncerramento: '',
    },
    faultClosingRequestMessages: {
      successMessage: 'Sucesso ao fazer a solicitação!',
      errorMessage: 'Falha ao fazer a solicitação',
    },
  }),
  computed: {
    getLabel() {
      if (this.isClosing) {
        return 'Desabilitar';
      }
      return 'Habilitar';
    },
    getChip() {
      if (this.isClosing) {
        return {
          label: 'habilitado',
          color: 'success',
        };
      }
      return {
        label: 'desabilitado',
        color: 'primary',
      };
    },
    isClosing() {
      return this.row.indHabilitadoEncerramento;
    },
  },
  created() {
    eventBus.$on('store-closing', (row = {}) => {
      this.handleDialogDisplay();
      this.row = row;
    });
  },
  methods: {
    handleDialogDisplay() {
      this.dialog = !this.dialog;
    },
    closingRequest() {
      this.handleChangeLoading();
      this.makeClosingRequest();
    },
    handleChangeLoading() {
      this.loading = !this.loading;
    },
    makeClosingRequest() {
      const { id, indHabilitadoEncerramento } = this.row;
      this.callService(
        this.requestClass.closingStore(id, !indHabilitadoEncerramento),
        this.faultClosingRequestMessages,
        this.closingCallBack,
      );
    },
    closingCallBack(success) {
      this.handleChangeLoading();
      if (success) {
        eventBus.$emit('store-closing-callback', success);
        this.handleDialogDisplay();
      }
    },
  },
};
</script>
